import { Skeleton as MuiSkeleton, SkeletonProps as MuiSkeletonProps } from '@mui/material'
import styled from 'styled-components'

export type SkeletonPropsType = MuiSkeletonProps

const Skeleton = styled(MuiSkeleton)<SkeletonPropsType>``

export default Skeleton
